module.exports = __webpack_public_path__ + "img/no_data_general.02ebd450.png";